import { render, staticRenderFns } from "./TaxCouponTab.vue?vue&type=template&id=14da0cca&scoped=true&"
import script from "./TaxCouponTab.vue?vue&type=script&lang=js&"
export * from "./TaxCouponTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da0cca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14da0cca')) {
      api.createRecord('14da0cca', component.options)
    } else {
      api.reload('14da0cca', component.options)
    }
    module.hot.accept("./TaxCouponTab.vue?vue&type=template&id=14da0cca&scoped=true&", function () {
      api.rerender('14da0cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/components/TaxCouponTab.vue"
export default component.exports